//@flow
import React from 'react';
import ContentRouter from "../../routers/contentRouter";

export const TitleContext = React.createContext(null)

const Content = () => {
	const [title, setTitle] = React.useState(null)
	const [toolbarBottom, setToolbarBottom] = React.useState(null)
	const [menuNavigation, setMenuNavigation] = React.useState(null)
	return (
		<TitleContext.Provider
			value={{
				title: title,
				setTitle: setTitle,
				toolbar: toolbarBottom,
				setToolbar: setToolbarBottom,
				menuNavigation,
				setMenuNavigation
			}}
		>
			<ContentRouter/>
		</TitleContext.Provider>
	)
}

export default Content;
